document.addEventListener("DOMContentLoaded", function () {
  // Splide setups
  var splide = new Splide(".splide-hear-the-difference", {
    perPage: 1,
    focus: "center",
    arrows: true,
    pagination: false,
    snap: true,
    speed: 750,
    classes: {
      arrows: "splide__arrows diff-splide-arrows",
      arrow: "splide__arrow diff-splide-arrow",
      prev: "splide__arrow--prev diff-splide-prev",
      next: "splide__arrow--next diff-splide-next",
    },
    arrowPath:
      "M22 13.7344L20.6 15.1844L24.15 18.7344H12V20.7344H24.15L20.6 24.2844L22 25.7344L28 19.7344L22 13.7344Z",
    breakpoints: {
      640: {
        gap: "16px",
        padding: { left: "16px", right: "16px" },
        perPage: 1,
      },
    },
  });

  var imageSplide = new Splide(".splide-image-wrapper", {
    perPage: 1,
    focus: "center",
    arrows: false,
    pagination: false,
    snap: true,
    speed: 850,
    breakpoints: {
      640: {
        gap: "16px",
        padding: { left: "8px", right: "8px" },
        perPage: 1,
      },
    },
  });

  imageSplide.sync(splide);
  splide.mount();
  imageSplide.mount();

  gsap.registerPlugin(ScrollTrigger);

  const isMobile = window.innerWidth <= 768;
  const bars = document.querySelectorAll(".hear-the-difference .bar");
  const hearTheDifference = document.querySelector(".hear-the-difference");

  if (bars.length && hearTheDifference) {
    const totalBars = bars.length;

    // Set initial staircase heights dynamically
    bars.forEach((bar, i) => {
      let baseHeight = isMobile ? 10 : 120; // highest bar
      let decrement = isMobile ? 2 : 25; // how much each next bar reduces

      let height = baseHeight - i * decrement;
      height = height < 0 ? 0 : height; // don't allow negative heights

      gsap.set(bar, { height: isMobile ? `${height}%` : `${height}px` });
    });

    // Timeline for dynamic bar animation
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: hearTheDifference,
        start: isMobile ? "top 100%" : "top bottom",
        end: isMobile ? "200% bottom" : "top 0",
        scrub: 0.5,
      },
    });

    tl.to(bars, {
      height: (i) => {
        let targetBaseHeight = isMobile ? 30 : 300;
        let targetDecrement = isMobile ? 5 : 50;

        let targetHeight = targetBaseHeight - i * targetDecrement;
        targetHeight = targetHeight < 0 ? 0 : targetHeight;

        return isMobile ? `${targetHeight}%` : `${targetHeight}px`;
      },
      ease: "none",
      stagger: {
        each: 0.1,
        ease: "none",
      },
    });
  }

  window.addEventListener("load", function () {
    // Background color transitions
    gsap.fromTo(
      [".index .hear-the-difference"],
      { backgroundColor: "#10120f" },
      {
        backgroundColor: "#fff",
        force3D: true,
        scrollTrigger: {
          trigger: ".index .word-visible",
          start: "top bottom",
          end: "top 10%",
          toggleActions: "play none none reverse",
        },
      }
    );

    // Text color transitions
    gsap.to(
      ".index .hear-the-difference .hear-the-difference-content-slider h3",
      {
        color: "#1A1F1B",
        force3D: true,
        scrollTrigger: {
          trigger: ".index .word-visible",
          start: "top 100%",
          end: "top 10%",
          toggleActions: "play none none reverse",
        },
      }
    );

    gsap.to(
      ".index .hear-the-difference .hear-the-difference-content-slider p",
      {
        color: "#646B66",
        force3D: true,
        scrollTrigger: {
          trigger: ".index .word-visible",
          start: "top 100%",
          end: "top 10%",
          toggleActions: "play none none reverse",
        },
      }
    );

    gsap.to(".index .hear-the-difference .heading h2", {
      color: "#1A1F1B",
      force3D: true,
      scrollTrigger: {
        trigger: ".index .word-visible",
        start: "top 100%",
        end: "top 10%",
        toggleActions: "play none none reverse",
      },
    });

    gsap.to(".index .hear-the-difference-parent .bar-overlay .bar", {
      backgroundColor: "#fff",
      scrollTrigger: {
        trigger: ".index .word-visible",
        start: "top 100%",
        end: "top 10%",
        toggleActions: "play none none reverse",
      },
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.querySelector(
    ".hear-the-difference-parent .bar-overlay"
  );
  if (overlay) {
    overlay.style.display = "flex";
    overlay.style.visibility = "visible";
  }
});
